import React from 'react'
import { useTranslation } from 'react-i18next';
import '../styles/header.css';
// import { Link} from "react-router-dom";

function Header() {
  const {t} = useTranslation();
  return (
    <div className="title">
      <h5>{t('TEXT_HEADER')}</h5>
      {/* <div className="list">
            <ul>
                <li><Link to="/">Home</Link></li>
                <li className="list-li"><Link to="login">Login</Link></li>
            </ul>
        </div> */}
    </div>
  )
}

export default Header